// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as DownloadBDefault } from '../../../assets/icons/default/general/download-b.svg?react';
import { ReactComponent as DownloadBSolid } from '../../../assets/icons/solid/general/DOWNLOAD-B.svg?react';
import { createIcons } from '../../Icon';
const DownloadBIcon = /* @__PURE__ */ createIcons('DownloadB', {
    default: DownloadBDefault,
    solid: DownloadBSolid
});
DownloadBIcon.supportedTypes = ['default', 'solid'];
DownloadBIcon.category = 'general';
export default DownloadBIcon;
